// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-16141ba8&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserProfileLink.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("196c1ef6", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-16141ba8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/UserProfileLink.vue
// module id = ./node_modules/vue-style-loader/index.js!./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-16141ba8&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/UserProfileLink.vue
// module chunks = 0